export const TYPE_OF_EMPLOYMENT = [
  { id: 1, name: 'Employed by a financial service provider' },
  { id: 2, name: 'Self-employed' },
];
